import axios from './http'

var depot = {}

depot.get = function ({ url,params, config = {} }) {
    return new Promise((resolve,reject)=> {
        axios.get(url, {params: params} ,config).then((res) => {
            if (res.status === 200) {
                let result =  res.data;
                resolve(result);
            }
        }).catch((error) => {
            reject(error);
            console.log(error);
        });
    })
};
depot.post = ({url,data}) => {
    return new Promise((resolve,reject)=>{
        axios.post(url, data).then(
            (res) => {
                if (res.status === 200) {
                    if (res.status === 200) {
                        let result = res.data;
                        resolve(result);
                    }
                }
            }).catch((error) => {
                reject(error)
            console.log(error);
        });
    })
}
// depot.post = function ({ url, data, cb }) {
//     axios.post(url, data).then(
//         (res) => {
//             if (res.status === 200) {
//                 if (res.status === 200) {
//                     let result = res.data;
//                     cb(result);
//                 }
//             }
//         }).catch((error) => {
//         console.log(error);
//     });
// };

export default () => {
    window.depot = depot;
};


// WEBPACK FOOTER //
// ./src/http/index.js